var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1723",
    "data-name": "Rectangle 1723",
    width: 32,
    height: 32,
    fill: "#a2a2a2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login_Icon",
    "data-name": "Login Icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3067",
    "data-name": "Path 3067",
    d: "M16,0A16,16,0,1,0,32,16v0A16,16,0,0,0,16.006,0Zm0,6.193a5.678,5.678,0,1,1-5.678,5.678h0A5.678,5.678,0,0,1,16,6.193m0,22.193a12.364,12.364,0,0,1-9.451-4.4,7.192,7.192,0,0,1,6.355-3.854,1.578,1.578,0,0,1,.459.071A8.564,8.564,0,0,0,16,20.645a8.514,8.514,0,0,0,2.638-.445,1.579,1.579,0,0,1,.459-.071,7.192,7.192,0,0,1,6.355,3.854A12.363,12.363,0,0,1,16,28.386Z",
    transform: "translate(0 0)",
    fill: "#a2a2a2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/Login Icon.60370feb3cdb9412024ae24f6f63b570.svg";
export { ForwardRef as ReactComponent };